/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import { useEffect, useState } from "react"

const TYPE_INTERVAL_MS = 100

const visuallyHidden = {
  position: "absolute",
  width: "1px",
  height: "1px",
  p: 0,
  m: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
}

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches

const SpecialHeader = ({ slogan, pageTitle }) => {
  const [shown, setShown] = useState("")

  useEffect(() => {
    // Array.from splits by code point, so emoji/astral chars are never torn apart
    const chars = Array.from(pageTitle || "")

    if (chars.length === 0 || prefersReducedMotion()) {
      setShown(chars.join(""))
      return undefined
    }

    setShown("")
    let i = 0
    const intervalId = setInterval(() => {
      i += 1
      setShown(chars.slice(0, i).join(""))
      if (i >= chars.length) clearInterval(intervalId)
    }, TYPE_INTERVAL_MS)
    return () => clearInterval(intervalId)
  }, [pageTitle])

  return (
    <div
      sx={{
        variant: "specialHeader",
      }}
    >
      {slogan} <span sx={visuallyHidden}>{pageTitle}</span>
      <div
        data-testid="typewriter"
        aria-hidden="true"
        sx={{
          fontWeight: "bold",
          display: "inline-block",
          pr: 2,
        }}
      >
        {shown}
      </div>
    </div>
  )
}
SpecialHeader.propTypes = {
  slogan: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
}

export default SpecialHeader
